import React, { useState, useEffect, useRef, useReducer } from 'react';
import Category from './Category';
import axios from 'axios';
import ResponseMeta from './ResponseMeta';
import { useParams, useHistory } from "react-router-dom";
import LoadingWheel from './LoadingWheel';
import { LoginPopup } from './Login';
import { unique } from 'jquery';


const Form = () => {
    const [uniqueResponse, setUniqueResponse] = useReducer((state, newState) => ({ ...state, ...newState }), { haveUsedBefore: 0, use: "", entity: "", faculty: "", unit: "" });
    const [entities, setEntities] = useState([]);
    const [schools, setSchools] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [showMeta, setShowMeta] = useState(true);
    const [questionResponses, setQuestionResponses] = useState([]);
    const [errors, setErrors] = useState([]);
    const [foundID, setFoundID] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);


    const schoolInput = useRef(null);
    const top = useRef(null);
    let history = useHistory();
    const { uniqueID, startSection } = useParams();
    const blockRefs = useRef([]);
    const titleRefs = useRef([]);

    let params = new URLSearchParams(window.location.search);

    const updateField = (field, value) => { setUniqueResponse({ [field]: value }); }
   
    useEffect(() => {
        console.log('init');
        axios.get('api/question', { withCredentials: true }).then(response => {
            setQuestions(response.data);
        });
        axios.get('api/category', { withCredentials: true }).then(response => {
            setCategories(response.data);
            blockRefs.current = blockRefs.current.slice(0, response.data.length);
            titleRefs.current = titleRefs.current.slice(0, response.data.length);
        });
        axios.get('api/entity').then(response => {
            setEntities(response.data);
        });
        axios.get('api/school').then(response => {
            setSchools(response.data);
        });
    }, [uniqueID]);
    useEffect(() => {
        if (questions.length > 0 && categories.length > 0 && schools.length > 0) {
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [questions, categories, entities, schools]);
    useEffect(() => {
        if (startSection == null) {
          //  console.log("hide meta");
            setShowMeta(false);
        } else {
            if (startSection != "meta") {
           //     console.log("hide meta");
                setShowMeta(false);
            } else {
                setShowMeta(true);
            }
        }
    }, [startSection]);

    useEffect(() => {
      //  console.log("questionResponses: " + questionResponses.length);
        if (questionResponses.length > 0) {
            setLoading(false);
        } else {
            setLoading(true);
        }

    }, [questionResponses]);


    useEffect(() => {
        console.log("questions  updated:" + questions.length);
        if (questions.length > 0) {
        var qs = [];
        if (uniqueID != 0) {
            // if not 0 then it's 'update' therefore autofill the form with the latest response          
            axios.get('api/uniqueresponse/' + uniqueID, { withCredentials: true }).then(response2 => {         
                setUniqueResponse(response2.data);
                if (sessionStorage.getItem('uniqueResponse' + uniqueID)) {
                    // restore if something is saved
                    setUniqueResponse(JSON.parse(sessionStorage.getItem('uniqueResponse' + uniqueID)));
                }
                axios.get('api/summary/' + uniqueID + '/' + response2.data.uniqueResponseID, { withCredentials: true }).then(response3 => {
                    questions.forEach((q) => {
                        var sum = response3.data.find(r => r.questionID == q.questionID);
                        if (sum) {
                          //  console.log(response3.data.find(r => r.questionID == q.questionID).responseText);
                            var qresponse = {
                                "questionID": q.questionID,
                                "responseText": sum.responseText,
                                "commentText": sum.commentText,
                                "questionText": q.questionText,
                                "questionInfo": q.questionInfo,
                                "categoryID": q.categoryID
                            };
                        }
                        else {
                            var qresponse = {
                                "questionID": q.questionID,
                                "responseText": "",
                                "commentText": "",
                                "questionText": q.questionText,
                                "questionInfo": q.questionInfo,
                                "categoryID": q.categoryID
                            };
                        }
                        qs.push(qresponse);
                      //  console.log("QS length: " + qs.length);
                    });
                    setQuestionResponses(qs);
                    if (sessionStorage.getItem('questionResponses' + uniqueID)) {
                        // restore if something is saved 
                        setQuestionResponses(JSON.parse(sessionStorage.getItem('questionResponses' + uniqueID)));
                    }
                });
                setFoundID(true);          
            }).catch(error => {
                setLoading(false);
                setFoundID(false);
            });
        } else {
            questions.forEach((q) => {
                var qresponse = {
                    "questionID": q.questionID,
                    "responseText": "",
                    "commentText": "",
                    "questionText": q.questionText,
                    "questionInfo": q.questionInfo,
                    "categoryID": q.categoryID
                };
                qs.push(qresponse);
            });
            setQuestionResponses(qs);

            if (sessionStorage.getItem('questionResponses' + uniqueID)) {
                // restore if something is saved 
                setQuestionResponses(JSON.parse(sessionStorage.getItem('questionResponses' + uniqueID)));
            }
            if (sessionStorage.getItem('uniqueResponse' + uniqueID)) {
                // restore if something is saved
                setUniqueResponse(JSON.parse(sessionStorage.getItem('uniqueResponse' + uniqueID)));
            }
        }
  
        }
      
    }, [questions]);

    const handleItemChange = (qid, field, value) => {        

        questionResponses.forEach((q) => {            
            if (q.questionID == qid) {
                q[field] = value;
           
            }
        
        });
       // console.log(field + ":" + value);
    }

    const closeAll = () => {
       // console.log(blockRefs.current);
        setShowAll(false);
            blockRefs.current.forEach((e) => {
                e.className = "questionBlock hide";                
            });
        titleRefs.current.forEach((e) => {
                e.className = "catTitleHide";
            });
            
    }
    const handleHeadingClick = (e, i) => {
    //    console.log(i);
        if (e.target.className == "catTitleHide") {
            e.target.className = "catTitleShow";       
            blockRefs.current[i].className = "questionBlock show";
        } else {
            e.target.className = "catTitleHide";         
            blockRefs.current[i].className = "questionBlock hide";
        }
    }
    const openAll = () => {
        setShowAll(true);
        blockRefs.current.forEach((e) => {
            e.className = "questionBlock show";
        });
        titleRefs.current.forEach((e) => {
            e.className = "catTitleShow";
        });
    }
    const backToTop = (e) => {
        e.preventDefault();
        top.current.scrollIntoView(true);


    }
    const handleNext = (e) => {
        e.preventDefault();
        var err = [];
        if (uniqueResponse.haveUsedBefore == 0) {
            err.push("haveUsedBefore");
        }
        if (uniqueResponse.use == "") {
            err.push("use");
        }
        if (uniqueResponse.entity == 0) {
            err.push("entity");
        }
        if (uniqueResponse.unit == "") {
            err.push("unit");
        }
        setErrors(err);
        if (err.length == 0) {
            sessionStorage.setItem('uniqueResponse' + uniqueID, JSON.stringify(uniqueResponse));
            history.push('duc' + (params.get("ltc") != null ? '?ltc=' : ''));
        }

       
    }

    const handleBack = (e) => {
        e.preventDefault();
        if (uniqueID == 0) {
            history.push('meta' + (params.get("ltc") != null ? '?ltc=' : ''));
            setShowMeta(true);
        } else {
            history.push('../../update');
        }
    }
    const handleSave = (e) => {
        e.preventDefault();
        save(false);
    }
    const save = (isDraft) => {
        // save to sessionStorage in case you get logged out
        sessionStorage.setItem('uniqueResponse' + uniqueID, JSON.stringify(uniqueResponse));
        sessionStorage.setItem('questionResponses' + uniqueID, JSON.stringify(questionResponses));
        axios.post('api/uniqueresponse', {                
            "haveUsedBefore": uniqueResponse.haveUsedBefore,
            "previousUniqueID": uniqueID,
            "use": uniqueResponse.use,
            "entity": uniqueResponse.entity,
            "faculty": uniqueResponse.faculty,
            "unit": uniqueResponse.unit,
            "isInternal": (params.get("ltc") != null ? true : false),
            "isDraft": isDraft
        }, { withCredentials: true }).then(response => {
            questionResponses.forEach((qr) => {
                qr.uniqueResponseID = response.data.uniqueResponseID;
                qr.AccessToken = (uniqueID != 0 ? uniqueID : response.data.uniqueToken);
            });
        //    console.log(response);
            sessionStorage.setItem('questionResponses', JSON.stringify(questionResponses));
            axios.post('api/questionresponse', questionResponses, { withCredentials: true }).then(r2 => {
       //         sessionStorage.removeItem('uniqueResponse' + uniqueID); sessionStorage.removeItem('questionResponses' + uniqueID);
                if (uniqueID != 0) {
                    history.push('/summary/update/' + uniqueID + '/' + response.data.uniqueResponseID);
                
                } else {
                    history.push('/summary/new/' + response.data.uniqueToken + '/' + response.data.uniqueResponseID);
                }
        
            }).catch(error => {
                if (401 === error.response.status) {
                    setOpen(true);
                }
            });

        }).catch (error => {
            if (401 === error.response.status) {
                setOpen(true);
            }
        });
       
    }
    const handleSaveDraft = (e) => {
        e.preventDefault();
        save(true);
    }
    const onAuthenticated = () => {
        setOpen(false);
    }
    return (
        <div>
            {loading ? <LoadingWheel message="Loading..." /> : <React.Fragment />}
            {showMeta ? 
                <React.Fragment>
                    <div className="content">
                        {errors.length != 0 ? <div className="row"><span className="error">Please ensure all fields are filled in.</span></div> : <React.Fragment />}
                        {entities.length && schools.length ? <ResponseMeta {...uniqueResponse} updateField={updateField} entities={entities} schools={schools} errors={errors} /> : <React.Fragment />}
            </div>
            <div className="page-nav">
                <div><a href={uniqueID == 0 ? "new" : "update"} className="link-small-back"> Back</a></div>
                <div><a href="#" className="link-small" onClick={handleNext}>Next</a></div>
                </div>
                </React.Fragment>
                :
                <React.Fragment>
                    <LoginPopup open={open} onAuthenticated={onAuthenticated} />
                   
                    <div className="content" ref={top}>     
                        {uniqueID == 0 ?
                            <>
                                <p>Expand the sections below and respond to the checkpoints in each category:</p>
                                <ul>
                                    <li><strong>Sufficient evidence</strong> of this checkpoint in the subject site that meets good practice standards.</li>
                                    <li><strong>Some evidence </strong> of this checkpoint in the subject site, this is a potential development opportunity.</li>
                                    <li><strong>No evidence </strong> of this checkpoint in the subject site, this is a potential development opportunity.</li>
                                    <li><strong>Not applicable </strong> to this subject/context.</li>
                                 </ul>

                                <p>For each checkpoint you also can add comments for your own purposes if you wish.</p>
                                <p>Click <strong>save and complete</strong> or <strong>save and continue later</strong> to access curated support resources, review your summary, and save a copy.</p>
                                </>
                            : <p>Below is the summary of your most recently completed DUC for this subject. As you reflect on your subject site, review the following checkpoints and update accordingly. Click <strong>save and complete</strong> or <strong>save and continue later</strong> to access curated support resources, review your updated summary, and save a copy.</p>}
                <div className="togglers"><span className="openAll" onClick={() => openAll()}> Open All</span><span className="openAll closeAll" onClick={() => closeAll()}> Close all</span></div>
                        {
                            questionResponses.length > 0 ? categories.map((c, i) => <Category questions={questionResponses} category={c} key={c.categoryID} index={i} show={showAll} handleItemChange={handleItemChange} titleRef={(ref) => titleRefs.current[i] = ref} blockRef={(ref) => blockRefs.current[i] = ref} handleHeadingClick={handleHeadingClick} backToTop={backToTop} />
                            ) : <div />
                        }
                   
            </div>
       
            <div className="page-nav">
                        <div><a href="#" onClick={handleBack} className="link-small-back"> Back</a></div>
                        <div className="page-nav-right">
                            <div><a href="#" className="link-small" onClick={handleSave}>Save and complete</a></div>
                            <div><a href="#" className="link-small" onClick={handleSaveDraft}>Save and continue later</a></div>

                            </div>                     
                    </div>
                </React.Fragment>
            }
        </div>
    )
}
export default Form;